module.exports = __webpack_public_path__ + "img/gate_img.0141563b.svg";